/* Croco menus – tiny helper for croco-menu.css.
   1. Desktop: measures ONCE (and on resize) how far each menu item is from the header's bottom edge,
      so the dropdown always starts flush with the header. No work on scroll or on mouse move.
   2. Phone/tablet drawer: turns families that have sub-families into a tap-to-open dropdown. */
(function () {
  var raf;

  function measure() {
    var header = document.querySelector('#header') || document.querySelector('.header');
    if (!header) return;
    var hb = header.getBoundingClientRect().bottom;
    document.querySelectorAll('.header ul.dt-desktop-menu > li').forEach(function (li) {
      var block = li.querySelector(':scope > div.sub-menu-block');
      if (!block || !li.offsetParent) return;
      var r = li.getBoundingClientRect();
      var gap = Math.round(hb - r.bottom);
      // ignore readings taken while the header is still settling (e.g. logo not sized yet) – CSS falls back to 13px
      if (gap >= 0 && gap <= 48) li.style.setProperty('--croco-menu-gap', gap + 'px');
      else li.style.removeProperty('--croco-menu-gap');
      // fly-outs open to the left if they would run off the screen
      var hasFly = block.querySelector('div.sub-menu-block');
      li.classList.toggle('croco-flip', !!hasFly && r.left + 264 + 240 > document.documentElement.clientWidth - 8);
    });
  }
  function schedule() { cancelAnimationFrame(raf); raf = requestAnimationFrame(measure); }

  function initDrawer() {
    document.querySelectorAll('.menu-drawer ul.sub-menu-lists > li.menu-item-has-children').forEach(function (li) {
      if (li.classList.contains('croco-acc')) return;
      var link = li.querySelector(':scope > a');
      var block = li.querySelector(':scope > div.sub-menu-block');
      var list = block && block.querySelector('ul.sub-menu-lists');
      if (!link || !list) return;
      li.classList.add('croco-acc');
      link.setAttribute('role', 'button');
      link.setAttribute('aria-expanded', 'false');
      // first entry inside: the family's own page, so it is still one tap away
      var href = link.getAttribute('href');
      if (href && href !== '#') {
        var all = document.createElement('li');
        all.className = 'croco-acc__all';
        var a = document.createElement('a');
        a.href = href;
        a.textContent = 'All ' + link.textContent.trim();
        all.appendChild(a);
        list.insertBefore(all, list.firstChild);
      }
      link.addEventListener('click', function (ev) {
        ev.preventDefault();
        var open = li.classList.toggle('is-open');
        link.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function init() { initDrawer(); schedule(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', init);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  if ('ResizeObserver' in window) {
    var h = document.querySelector('#header') || document.querySelector('.header');
    if (h) new ResizeObserver(schedule).observe(h);
  }
})();
